import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const calculateWidth = (text) => {
  if (!text) return 50;

  // Average character width for 13px font (approximation)
  const avgCharWidth = 7.5;

  // Base calculation with min and max constraints
  const width = Math.min(
    Math.max(text.length * avgCharWidth, 30), // Minimum width of 30px
    400 // Maximum width of 400px
  );

  return width;
};

const DynamicTextSkeleton = ({ text, isLoading, testId }) => {
  if (isLoading) {
    return (
      <Skeleton
        width={calculateWidth(text)}
        height={16}
        containerTestId={testId ? `skeleton-${testId}` : undefined}
      />
    );
  }
  return <span>{text}</span>;
};

DynamicTextSkeleton.propTypes = {
  text: PropTypes.string,
  isLoading: PropTypes.bool,
  testId: PropTypes.string,
};

export default DynamicTextSkeleton;
